/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Signup_PromptInputs */

const en_auth__signup_prompt = /** @type {(inputs: Auth__Signup_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth__Signup_PromptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__signup_prompt = /** @type {((inputs?: Auth__Signup_PromptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Signup_PromptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__signup_prompt(inputs)
});